import { render, staticRenderFns } from "./ViewAcademyClass.vue?vue&type=template&id=0bd32677&scoped=true"
import script from "./ViewAcademyClass.vue?vue&type=script&lang=js"
export * from "./ViewAcademyClass.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademyClass.vue?vue&type=style&index=0&id=0bd32677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd32677",
  null
  
)

export default component.exports